import { useEffect } from "react";
import { usePage } from '@inertiajs/inertia-react';

// Mode "bl": la web dins d'un iframe

export const useBl = () => !!usePage().props.bl;

export const ambBl = (href) => {
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return href;
    if (/^\/([a-z]{2}\/)?bl\//.test(url.pathname) || url.searchParams.get("bl") === "1") return href;
    url.searchParams.set("bl", "1");
    return url.pathname + url.search + url.hash;
};

export const useEnllacosBl = (bl) => {
    useEffect(() => {
        if (!bl) return;

        document.body.classList.add("bl-iframe");

        const alClicar = (e) => {
            const a = e.target.closest && e.target.closest("a[href]");
            if (!a) return;
            const href = a.getAttribute("href");
            if (!href || href.startsWith("#") || /^(mailto|tel|javascript):/i.test(href)) return;
            a.setAttribute("href", ambBl(href));
        };

        document.addEventListener("click", alClicar, true);
        document.addEventListener("auxclick", alClicar, true);
        return () => {
            document.removeEventListener("click", alClicar, true);
            document.removeEventListener("auxclick", alClicar, true);
            document.body.classList.remove("bl-iframe");
        };
    }, [bl]);
};
